/**
 * Creates a promise that resolves after the specified number of milliseconds.
 * @util
 *
 * @param ms - Number of milliseconds to wait
 * @returns A promise that resolves after the specified delay
 *
 * @example
 * ```typescript
 * // Wait for 1 second
 * await waitFor(1000);
 * ```
 */
export function waitFor(ms, result) {
    return new Promise(resolve => {
        setTimeout(() => resolve(result), ms);
    });
}
//# sourceMappingURL=waitFor.js.map